"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const formik_1 = require("formik");
const InputField = (_a) => {
    var { name, id, type, autoComplete, label, disabled = false } = _a, rest = __rest(_a, ["name", "id", "type", "autoComplete", "label", "disabled"]);
    const { touched, errors, isSubmitting } = (0, formik_1.useFormikContext)();
    const isInvalid = touched[name] && errors[name];
    const errorId = `${id}-error`;
    const inputRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (isInvalid && isSubmitting && inputRef.current) {
            inputRef.current.focus();
        }
    }, [isInvalid, isSubmitting, inputRef]);
    const getAutocompleteAttribute = (key) => {
        const autocompleteMapping = {
            homeAddress: 'home street-address',
            homeZipCode: 'home postal-code',
            homePostalAddress: 'home address-level2',
            homePhone: 'home tel',
            homeOtherPhone: 'home tel',
            homeMobilePhone: 'home tel',
            homeEMail: 'home email',
            workPlace: 'work organization',
            workAddress: 'work street-address',
            workZipCode: 'work postal-code',
            workPostalAddress: 'work address-level2',
            workPhone: 'work tel',
            workEMail: 'work email',
            otherAddress: 'other street-address',
            otherZipCode: 'other postal-code',
            otherPostalAddress: 'other address-level2',
            otherPhone: 'other tel',
            preferredAddressType: '',
        };
        return autocompleteMapping[key] || 'off'; // Default to "off" if no mapping exists
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: `input-field ${type === 'hidden' ? 'hidden' : ''}`, children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: id, className: isInvalid ? 'label-invalid' : '', children: label }), (0, jsx_runtime_1.jsx)(formik_1.Field, Object.assign({ innerRef: inputRef, name: name, id: id, type: type, autoComplete: autoComplete || getAutocompleteAttribute(name), disabled: disabled, className: `input-form-element ${isInvalid ? 'invalid' : ''}`, "aria-invalid": isInvalid ? 'true' : 'false', "aria-describedby": isInvalid ? errorId : undefined }, rest)), (0, jsx_runtime_1.jsx)("div", { id: errorId, className: "field-error", children: (0, jsx_runtime_1.jsx)(formik_1.ErrorMessage, { name: name, component: "span" }) })] }));
};
exports.default = InputField;
